import { useNavigate, useLocation } from 'react-router-dom';
import { FormPage } from '@/components/forms/FormPage';
import CreateAddressForm from '@/components/CreateAddressForm';
import { useProfileData } from '@/hooks/useProfileData';
import { SFIcon } from '@/components/ui/sf-icon';
import { sfIcons } from '@/lib/sf-icons';

export default function AddAddressPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bridgeCustomerId, customerId } = useProfileData();

  const handleCreated = () => {
    // Navigate back to the page we came from, or dashboard as fallback
    const state = location.state as { returnPath?: string } | null;
    const returnPath = state?.returnPath || '/dashboard';
    navigate(returnPath, { replace: true });
  };

  return (
    <FormPage
      icon={sfIcons.mapPin}
      title="Create Liquidation Address"
      subtitle="Generate a new crypto address to receive payments that will be automatically converted to fiat"
      // Don't set returnPath prop - let FormPage use location.state.returnPath
      // This allows proper navigation back to /dashboard/receive if that's where we came from
    >
      <CreateAddressForm 
        bridgeCustomerId={bridgeCustomerId}
        customerId={customerId}
        onCreated={handleCreated} 
      />
    </FormPage>
  );
}

